export enum OrganizationType {
    All = 1,
    Regular = 2,
    Children = 3,
    Dogs = 4,
    Pacemaker = 5,
    TwelveChannelHolter = 6
}
